"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegrationEnv = void 0;
var IntegrationEnv;
(function (IntegrationEnv) {
    IntegrationEnv["PROD"] = "prod";
    IntegrationEnv["BETA"] = "beta";
    IntegrationEnv["DEV"] = "dev";
})(IntegrationEnv = exports.IntegrationEnv || (exports.IntegrationEnv = {}));
//# sourceMappingURL=IntegrationEnv.js.map